import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";

export function ReferralBanner() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <Link
      to="/ai-investing-club/refer"
      className="group flex items-center justify-between gap-3 px-4 py-2.5 rounded-md border border-accent/30 bg-accent/5 hover:bg-accent/10 transition-colors text-sm"
    >
      <span className="flex items-center gap-2 text-foreground">
        <Gift className="w-4 h-4 text-accent" />
        Refer 7 friends, get a free month of Club Premium.
      </span>
      <span className="inline-flex items-center gap-1 text-accent">
        Get your link <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
      </span>
    </Link>
  );
}
